import { ListingOperator } from '../rentalListing'

export const isAdminManagedListing = (listingOperators: ListingOperator[]) => {
  return !!listingOperators.find((listingOperator) => listingOperator.email.toLowerCase().endsWith('@guiker.com'))
}
